import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/auth.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  modalOrcamento:boolean = false;
  tipoUsuario:any = "";
  usuario:any = "";
  
  constructor(public auth: AuthService) { }

  ngOnInit() {
    this.usuario = localStorage.getItem('usuarioVibe');
    this.tipoUsuario = this.auth.tipoUsuario;
    if(this.tipoUsuario == ""){
      this.tipoUsuario = localStorage.getItem('tipoUsuario');
    }
  }

  openModal(){
    let modal:any = document.getElementById('myModal')
    modal.style.display = "block";
  }
  
  closeModal(){
    let modal:any = document.getElementById('myModal')
    modal.style.display = "none";
  }

  openModalTurmas(){
    let modalTurmas:any = document.getElementById('myModalTurmas')
    modalTurmas.style.display = "block";
  }
  
  closeModalTurmas(){
    let modalTurmas:any = document.getElementById('myModalTurmas')
    modalTurmas.style.display = "none";
  }

}
